module.exports = require('./helpers/bundle-url').getBundleURL('9p9yL') + "CourierPrime-Bold.3d6bf689.ttf";